var _rect, _mask, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo48V1 = function SvgLogo48V1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 42,
    height: 42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84009 3.83984H44.1601V44.1598H3.84009V3.83984Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1602 23.9994C44.1602 35.134 35.1343 44.1598 24.0006 44.1598C12.866 44.1598 3.84009 35.134 3.84009 23.9994C3.84009 12.8648 12.866 3.83984 24.0006 3.83984C35.1343 3.83984 44.1602 12.8648 44.1602 23.9994Z",
    fill: "#36A9E0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8803 30.073L23.736 20.4075L18.0109 30.0364C17.7584 30.461 17.3105 30.7198 16.828 30.7198H11.6802L21.4427 14.0731C21.9053 13.295 22.7303 12.8142 23.6243 12.8C24.5133 12.7891 25.3564 13.2416 25.842 14.0063L36.3202 30.7198H31.0407C30.5731 30.7198 30.1369 30.4767 29.8803 30.073Z",
    fill: "#FDFBFC"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo48V1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_48_v1.c5809bb46e52667d554b6d672cb766ac.svg";